import axios from '@/api/axios';
import * as c_Interface from '@/interface/components/manageGroups';
import { VendorForm, AddressForm, GrantForm, ManufacturerForm } from '@/interface/components';

export const getGroups = () => axios.get(`/groups`);
export const setGroups = (payload: any) => axios.post(`/groups`, payload);
export const deleteGroups = (groupId: string) => axios.delete(`/groups/${groupId}`);

export const getMe = (groupId: string) => axios.get(`/groups/${groupId}/members/me`);
export const getMembers = (groupId: string) => axios.get(`/groups/${groupId}/members`);
export const setMembers = (groupId: string, payload: Array<c_Interface.Member>) =>
  axios.post(`/groups/${groupId}/members`, payload);
export const reminders = (
  groupId: string,
  memberId: string,
  payload: c_Interface.ReminderPayload
) => axios.put(`/groups/${groupId}/members/${memberId}/reminders`, payload);
export const updateMembers = (
  groupId: string,
  memberId: string,
  memberFilter: { isAdmin: boolean }
) => axios.put(`/groups/${groupId}/members/${memberId}`, memberFilter);
export const deleteMembers = (groupId: string, memberId: string) =>
  axios.delete(`/groups/${groupId}/members/${memberId}`);

export const getMainLocations = (groupId: string) => axios.get(`/groups/${groupId}/locations`);
export const setMainLocation = (groupId: string, payload: c_Interface.CreateLocationPayload) =>
  axios.post(`/groups/${groupId}/locations`, payload);
export const deleteMainLocation = (groupId: string, locationId: string) =>
  axios.delete(`/groups/${groupId}/locations/${locationId}`);
export const updateMainLocation = (
  groupId: string,
  locationId: string,
  payload: c_Interface.CreateLocationPayload
) => axios.put(`/groups/${groupId}/locations/${locationId}`, payload);
export const getSubLocations = (groupId: string, locationId: string) =>
  axios.get(`/groups/${groupId}/locations/${locationId}/sub`);
export const getSubLocation = (groupId: string, locationId: string, subId: string) =>
  axios.get(`/groups/${groupId}/locations/${locationId}/sub/${subId}`);
export const setSubLocation = (
  groupId: string,
  locationId: string,
  payload: c_Interface.CreateLocationPayload
) => axios.post(`/groups/${groupId}/locations/${locationId}/sub`, payload);
export const updateSubLocation = (
  groupId: string,
  locationId: string,
  subId: string,
  payload: c_Interface.CreateLocationPayload
) => axios.put(`/groups/${groupId}/locations/${locationId}/sub/${subId}`, payload);
export const deleteSubLocation = (groupId: string, locationId: string, subId: string) =>
  axios.delete(`/groups/${groupId}/locations/${locationId}/sub/${subId}`);

export const getTypes = (groupId: string) => axios.get(`/groups/${groupId}/types`);
export const setType = (groupId: string, payload: c_Interface.CustomFieldPayload) =>
  axios.post(`/groups/${groupId}/types`, payload);
export const deleteType = (groupId: string, typeId: string) =>
  axios.delete(`/groups/${groupId}/types/${typeId}`);
export const updateType = (groupId: string, typeId: string, payload: { name: string }) =>
  axios.put(`/groups/${groupId}/types/${typeId}`, payload);
export const getTypeFields = (groupId: string, typeId: string) =>
  axios.get(`/groups/${groupId}/types/${typeId}/fields`);
export const getTypeField = (groupId: string, typeId: string, fieldId: string) =>
  axios.get(`/groups/${groupId}/types/${typeId}/fields/${fieldId}`);
export const setTypeField = (
  groupId: string,
  typeId: string,
  payload: c_Interface.CustomFieldPayload
) => axios.post(`/groups/${groupId}/types/${typeId}/fields`, payload);
export const deleteTypeField = (groupId: string, typeId: string, fieldId: string) =>
  axios.delete(`/groups/${groupId}/types/${typeId}/fields/${fieldId}`);
export const updateTypeField = (
  groupId: string,
  typeId: string,
  fieldId: string,
  payload: c_Interface.CustomFieldPayload
) => axios.put(`/groups/${groupId}/types/${typeId}/fields/${fieldId}`, payload);

export const getVendors = (groupId: string) => axios.get(`/groups/${groupId}/vendors`);
export const getVendor = (groupId: string, vendorId: string) =>
  axios.get(`/groups/${groupId}/vendors/${vendorId}`);
export const setVendor = (groupId: string, payload: c_Interface.CreateVendorPayload) =>
  axios.post(`/groups/${groupId}/vendors`, payload);
export const updateVendor = (groupId: string, vendorId: string, payload: VendorForm) =>
  axios.put(`/groups/${groupId}/vendors/${vendorId}`, payload);
export const deleteVendor = (groupId: string, vendorId: string) =>
  axios.delete(`/groups/${groupId}/vendors/${vendorId}`);

export const getManufacturers = (groupId: string) => axios.get(`/groups/${groupId}/manufacturers`);
export const getManufacturer = (groupId: string, vendorId: string) =>
  axios.get(`/groups/${groupId}/manufacturers/${vendorId}`);
export const setManufacturer = (groupId: string, payload: c_Interface.CreateManufacturerPayload) =>
  axios.post(`/groups/${groupId}/manufacturers`, payload);
export const updateManufacturer = (groupId: string, vendorId: string, payload: ManufacturerForm) =>
  axios.put(`/groups/${groupId}/manufacturers/${vendorId}`, payload);
export const deleteManufacturer = (groupId: string, vendorId: string) =>
  axios.delete(`/groups/${groupId}/manufacturers/${vendorId}`);

export const getAddresses = (groupId: string) => axios.get(`/groups/${groupId}/addresses`);
export const getAddress = (groupId: string, addressId: string) =>
  axios.get(`/groups/${groupId}/addresses/${addressId}`);
export const setAddress = (groupId: string, payload: c_Interface.CreateAddressPayload) =>
  axios.post(`/groups/${groupId}/addresses`, payload);
export const updateAddress = (groupId: string, addressId: string, payload: AddressForm) =>
  axios.put(`/groups/${groupId}/addresses/${addressId}`, payload);
export const deleteAddress = (groupId: string, addressId: string) =>
  axios.delete(`/groups/${groupId}/addresses/${addressId}`);

export const getGrants = (groupId: string) => axios.get(`/groups/${groupId}/grants`);
export const getGrant = (groupId: string, grantId: string) =>
  axios.get(`/groups/${groupId}/grants/${grantId}`);
export const setGrant = (groupId: string, payload: c_Interface.CreateGrantPayload) =>
  axios.post(`/groups/${groupId}/grants`, payload);
export const updateGrant = (groupId: string, grantId: string, payload: GrantForm) =>
  axios.put(`/groups/${groupId}/grants/${grantId}`, payload);
export const deleteGrant = (groupId: string, grantId: string) =>
  axios.delete(`/groups/${groupId}/grants/${grantId}`);

export const getSettings = (groupId: string) => axios.get(`/groups/${groupId}/settings`);
export const updateSetting = (groupId: string, payload: c_Interface.SettingPayload) =>
  axios.put(`/groups/${groupId}/settings`, payload);
